/*eslint-disable */
const config = {
	common: {
		router: 'common', // 路由文件配置 对应src/router/modules下的文件名
		pages: {
			index: {
				entry: "src/projects/common/main.js",
				template: "public/index.html",
				filename: "index.html",
				chunks: ['npm.lodash', 'vendors~index', 'npm.font-awesome', 'npm.core-js', 'npm.vuex', 'npm.axios',
					'runtime', 'npm.sockjs-client', 'npm.ctrl', 'npm.vue', 'npm.vueuse', 'npm.vue-router', 'npm.element-plus',
					'npm.async-validator', 'npm.webpack-dev-server', 'npm.jquery', 'npm.xe-utils', 'npm.url',
					'npm.svg-sprite-loader', 'npm.html-entities', 'npm.buffer', 'index', 'npm.popperjs'],
			},
		},
		devServer: {
			port: 3000,
			open: false, // 是否自动打开浏览器页面
			host: "0.0.0.0", // 指定使用一个 host，默认是 localhost
			https: false, // 使用https提供服务
			disableHostCheck: true,
			// 取消eslint的校验
			overlay: {
				warnings: false,
				errors: false
			}
		},
	},
	simple: {
		router: 'simple', // 路由文件配置 对应src/router/modules下的文件名
		pages: {
			index: {
				entry: "src/projects/simple/main.js",
				template: "public/index.html",
				filename: "index.html",
				chunks: ['npm.lodash', 'vendors~index', 'npm.font-awesome', 'npm.core-js', 'npm.vuex', 'npm.axios',
					'runtime', 'npm.sockjs-client', 'npm.ctrl', 'npm.vue', 'npm.vueuse', 'npm.vue-router', 'npm.element-plus',
					'npm.async-validator', 'npm.webpack-dev-server', 'npm.jquery', 'npm.xe-utils', 'npm.url',
					'npm.svg-sprite-loader', 'npm.html-entities', 'npm.buffer', 'index', 'npm.popperjs'],
			},
		},
		devServer: {
			port: 3000,
			open: false, // 是否自动打开浏览器页面
			host: "0.0.0.0", // 指定使用一个 host，默认是 localhost
			https: false, // 使用https提供服务
			disableHostCheck: true,
			// 取消eslint的校验
			overlay: {
				warnings: false,
				errors: false
			}
		},
	},
	'tech-blue': {
		router: 'tech-blue', // 路由文件配置 对应src/router/modules下的文件名
		pages: {
			index: {
				entry: "src/projects/tech-blue/main.js",
				template: "public/index.html",
				filename: "index.html",
				chunks: ['npm.lodash', 'vendors~index', 'npm.font-awesome', 'npm.core-js', 'npm.vuex', 'npm.axios',
					'runtime', 'npm.sockjs-client', 'npm.ctrl', 'npm.vue', 'npm.vueuse', 'npm.vue-router', 'npm.element-plus',
					'npm.async-validator', 'npm.webpack-dev-server', 'npm.jquery', 'npm.xe-utils', 'npm.url',
					'npm.svg-sprite-loader', 'npm.html-entities', 'npm.buffer', 'index', 'npm.popperjs'],
			},
		},
		devServer: {
			port: 3000,
			open: false, // 是否自动打开浏览器页面
			host: "0.0.0.0", // 指定使用一个 host，默认是 localhost
			https: false, // 使用https提供服务
			disableHostCheck: true,
			// 取消eslint的校验
			overlay: {
				warnings: false,
				errors: false
			}
		},
	},
};

module.exports = config;